import WithRender from "../../templates/base/productParts.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getActiveProductPartName",
      "getActiveProductPageOptions",
      "getActivePageOptions",
      "getMatrixComplete"
    ])
  },

  methods: {
    getProductPageOptionValues: function (pageOption) {
      return this.getActiveProductPageOptions[pageOption].values;
    }
  }
});
